export default __webpack_public_path__ + "resources/icons/n340-8dd5.png";